import { Component, OnDestroy, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { Toast } from "primeng/toast";
import { SignalRService } from "../app/services/signalr.service";
import { Globals } from "./models/lib/globals";
import { Router, NavigationEnd } from "@angular/router";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-root",
  template: `<p-toast position="top-center"></p-toast><router-outlet></router-outlet>`,
  standalone: true,
  imports: [RouterOutlet, Toast],
})
export class AppComponent implements OnInit, OnDestroy {
  private routerSubscription!: Subscription;

  constructor(
    private signalrService: SignalRService,
    private globalService: Globals,
    private router: Router
  ) {}

  ngOnInit() {
    this.signalrService.startConnection();

    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (event.url.includes("procedure-view-print")) {
          document.body.classList.add("print");
        } else {
          document.body.classList.remove("print");
        }
      });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
